// enum.js

import request from '@/utils/request';

export function getEnum() {
  return request({
    url: '/v1/forum_enum_info/list',
    method: 'get',
  });
}
